export default "__VITE_ASSET__BiaDABpx__"